import React, { useEffect, useState } from 'react';

const PaymentSuccess = () => {
  const [countdown, setCountdown] = useState(10);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    // Trigger entrance animation
    setTimeout(() => setIsVisible(true), 100);

    // Handle resize
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          window.location.href = 'https://teams.microsoft.com/';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      padding: isMobile ? '1rem' : '2rem',
      position: 'relative'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `radial-gradient(circle at 25% 25%, rgba(224, 79, 96, 0.03) 0%, transparent 50%),
                         radial-gradient(circle at 75% 75%, rgba(224, 79, 96, 0.03) 0%, transparent 50%)`,
        pointerEvents: 'none'
      }} />

      {/* Header Logo */}
      <div style={{
        position: 'absolute',
        top: isMobile ? '1rem' : '2rem',
        left: isMobile ? '1rem' : '2rem',
        display: 'flex',
        alignItems: 'center',
        zIndex: 10
      }}>
        <img 
          src="/assets/cheese2.png" 
          width={isMobile ? 28 : 32} 
          alt="Ricotta" 
          style={{ marginRight: '0.5rem' }} 
        />
        <span style={{ 
          color: '#E04F60', 
          fontWeight: '700', 
          fontSize: isMobile ? '1.1rem' : '1.2rem',
          letterSpacing: '-0.025em'
        }}>
          Ricotta
        </span>
      </div>

      {/* Main Content */}
      <div 
        className={`payment-success-container ${isVisible ? 'animate-in' : ''}`}
        style={{
          maxWidth: isMobile ? '95%' : '650px',
          width: '100%',
          background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
          borderRadius: '24px',
          padding: isMobile ? '2.5rem 1.5rem' : '4rem 3rem',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08), 0 8px 25px rgba(0, 0, 0, 0.04)',
          border: '1px solid rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(10px)',
          position: 'relative',
          overflow: 'hidden',
          transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
          opacity: isVisible ? 1 : 0,
          transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        {/* Subtle background glow */}
        <div style={{
          position: 'absolute',
          top: '-50%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '120%',
          height: '200%',
          background: 'radial-gradient(ellipse at center, rgba(224, 79, 96, 0.03) 0%, transparent 70%)',
          pointerEvents: 'none',
          zIndex: 0
        }} />

        {/* Content */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          {/* Success Icon */}
          <div style={{ 
            marginBottom: isMobile ? '1.5rem' : '2rem',
            transform: isVisible ? 'scale(1)' : 'scale(0.8)',
            transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.2s'
          }}>
            <div style={{
              width: isMobile ? '80px' : '100px',
              height: isMobile ? '80px' : '100px',
              background: 'linear-gradient(135deg, #27AE60 0%, #2ECC71 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              boxShadow: '0 10px 30px rgba(39, 174, 96, 0.3)',
              animation: isVisible ? 'pulse-success 2s infinite' : 'none'
            }}>
              <i className="fas fa-check" style={{
                fontSize: isMobile ? '2.5rem' : '3rem',
                color: 'white'
              }}></i>
            </div>
          </div>

          {/* Title */}
          <h1 style={{
            color: '#2C3E50',
            fontSize: isMobile ? '2rem' : '2.5rem',
            fontWeight: '700',
            marginBottom: '1rem',
            letterSpacing: '-0.025em',
            lineHeight: '1.2'
          }}>
            Subscription Successful! 🎉
          </h1>

          {/* Subtitle */}
          <p style={{
            color: '#6c757d',
            fontSize: isMobile ? '1rem' : '1.1rem',
            lineHeight: '1.6',
            marginBottom: isMobile ? '1.5rem' : '2rem',
            maxWidth: '450px',
            margin: `0 auto ${isMobile ? '1.5rem' : '2rem'} auto`
          }}>
            Thank you for subscribing to <strong style={{ color: '#E04F60' }}>Ricotta Games & Trivia</strong>! 
            Your team can now enjoy unlimited access to all our engaging games and activities.
          </p>

          {/* Feature Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
            gap: isMobile ? '1rem' : '1.5rem',
            margin: isMobile ? '1.5rem 0' : '2rem 0',
            padding: isMobile ? '1.5rem' : '2rem',
            background: 'rgba(224, 79, 96, 0.04)',
            borderRadius: '16px',
            border: '1px solid rgba(224, 79, 96, 0.08)'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '48px',
                height: '48px',
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 0.75rem auto'
              }}>
                <i className="fas fa-gamepad" style={{ fontSize: '1.25rem', color: 'white' }}></i>
              </div>
              <h6 style={{ color: '#2C3E50', marginBottom: '0.25rem', fontWeight: '600' }}>17+ Games</h6>
              <small style={{ color: '#6c757d' }}>Interactive team activities</small>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '48px',
                height: '48px',
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 0.75rem auto'
              }}>
                <i className="fas fa-trophy" style={{ fontSize: '1.25rem', color: 'white' }}></i>
              </div>
              <h6 style={{ color: '#2C3E50', marginBottom: '0.25rem', fontWeight: '600' }}>Weekly Trivia</h6>
              <small style={{ color: '#6c757d' }}>Competitive team contests</small>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '48px',
                height: '48px',
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 0.75rem auto'
              }}>
                <i className="fas fa-users" style={{ fontSize: '1.25rem', color: 'white' }}></i>
              </div>
              <h6 style={{ color: '#2C3E50', marginBottom: '0.25rem', fontWeight: '600' }}>Team Building</h6>
              <small style={{ color: '#6c757d' }}>Icebreakers & social games</small>
            </div>
          </div>

          {/* Countdown Section */}
          <div style={{
            background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
            color: 'white',
            padding: isMobile ? '1.25rem' : '1.5rem',
            borderRadius: '16px',
            marginBottom: isMobile ? '1.5rem' : '2rem',
            boxShadow: '0 8px 25px rgba(224, 79, 96, 0.25)'
          }}>
            <h5 style={{ 
              marginBottom: '0.75rem', 
              fontWeight: '600',
              fontSize: isMobile ? '1.1rem' : '1.25rem'
            }}>
              <i className="fab fa-microsoft me-2"></i>
              Redirecting to Microsoft Teams...
            </h5>
            <div style={{
              fontSize: isMobile ? '1.75rem' : '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              fontFamily: 'monospace'
            }}>
              {countdown}
            </div>
            <small style={{ opacity: 0.9, fontSize: '0.9rem' }}>seconds remaining</small>
          </div>

          {/* Action Buttons */}
          <div style={{
            display: 'flex',
            gap: isMobile ? '0.75rem' : '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginBottom: isMobile ? '1.5rem' : '2rem'
          }}>
            <button 
              onClick={() => window.location.href = 'https://teams.microsoft.com/'}
              style={{
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                border: 'none',
                color: 'white',
                fontWeight: '600',
                padding: isMobile ? '12px 20px' : '14px 28px',
                borderRadius: '50px',
                fontSize: '0.95rem',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: '0 6px 20px rgba(224, 79, 96, 0.3)',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                whiteSpace: 'nowrap'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 10px 30px rgba(224, 79, 96, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 6px 20px rgba(224, 79, 96, 0.3)';
              }}
            >
              <i className="fab fa-microsoft"></i>
              Go to Teams Now
            </button>

            <a 
              href="https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-start-a-game-on-a-team-channel"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: 'transparent',
                border: '2px solid #E04F60',
                color: '#E04F60',
                fontWeight: '600',
                padding: isMobile ? '10px 18px' : '12px 26px',
                borderRadius: '50px',
                fontSize: '0.95rem',
                textDecoration: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                whiteSpace: 'nowrap'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#E04F60';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#E04F60';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <i className="fas fa-rocket"></i>
              {isMobile ? 'Get Started' : 'Getting Started Guide'}
            </a>
          </div>

          {/* Support Section */}
          <div style={{
            borderTop: '1px solid rgba(0,0,0,0.08)',
            paddingTop: isMobile ? '1.25rem' : '1.5rem',
            color: '#6c757d',
            fontSize: '0.9rem'
          }}>
            <p style={{ marginBottom: '0' }}>
              Need help? Contact us at{' '}
              <a 
                href="mailto:cheese@ricotta.team" 
                style={{ 
                  color: '#E04F60', 
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
              >
                cheese@ricotta.team
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Add animations */}
      <style jsx>{`
        @keyframes pulse-success {
          0%, 100% {
            box-shadow: 0 10px 30px rgba(39, 174, 96, 0.3);
          }
          50% {
            box-shadow: 0 10px 30px rgba(39, 174, 96, 0.5);
          }
        }
        
        .animate-in {
          animation: slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentSuccess;